export default "__VITE_ASSET__CTgoJ4_M__"